"use strict";
/**
 * Shared media size allowlist.
 *
 * Because the media route is public, arbitrary `w`/`h` values would let anyone
 * create unbounded derived objects. Dimensions are snapped up to the nearest
 * allowlisted value — on the server by `parse-transformation.ts`, and client-side
 * by the two dynamic call sites so URLs stay stable.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_MEDIA_SIZE = exports.MEDIA_SIZE_ALLOWLIST = void 0;
exports.snapMediaSize = snapMediaSize;
exports.MEDIA_SIZE_ALLOWLIST = [
    30, 50, 140, 150, 200, 300, 400, 420, 500, 630, 800, 1024, 1172, 1200, 1600,
];
exports.MAX_MEDIA_SIZE = exports.MEDIA_SIZE_ALLOWLIST[exports.MEDIA_SIZE_ALLOWLIST.length - 1];
function snapMediaSize(value) {
    var _a;
    if (!Number.isFinite(value) || value < exports.MEDIA_SIZE_ALLOWLIST[0]) {
        return exports.MEDIA_SIZE_ALLOWLIST[0];
    }
    return (_a = exports.MEDIA_SIZE_ALLOWLIST.find(size => size >= value)) !== null && _a !== void 0 ? _a : exports.MAX_MEDIA_SIZE;
}
